import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.some.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "container pb-4 pt-4 px-3 px-md-0"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', [_vm._v("State Score Card")]), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(" This view provides more detail about how each indicator is calculated into points, and that is added up for domain points and designations, and then overall points and a designation. For every measure, ISBE created a scoring range by setting a minimum standard and a target. ")]), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        return _vm.showVideoModal($event);
      }
    }
  }, [_c('i', {
    staticClass: "far fa-play-circle"
  }), _vm._v(" Watch a video about the IEPP's goals!! ")])]), _vm._m(0), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _c('tbody', [_vm._l(_vm.domains, function (domain) {
    return [_c('DomainRow', {
      key: `domain_${domain.DomainId}`,
      attrs: {
        "domain": domain,
        "facts": _vm.facts.filter(x => domain.Indicators.some(y => y.DomainIndicatorId === x.DomainIndicatorId))
      }
    }), _vm._l(domain.Indicators, function (indicator) {
      return _c('DomainIndicatorRow', {
        key: `domainIndicator_${indicator.DomainIndicatorId}`,
        staticClass: "py-2 py-md-0",
        attrs: {
          "domain": domain,
          "domain-indicator": indicator,
          "fact": _vm.facts.find(x => x.DomainIndicatorId === indicator.DomainIndicatorId)
        }
      });
    })];
  })], 2), _c('thead', {
    staticClass: "table-dark font-weight-bold"
  }, [_c('tr', [_c('th', {
    staticClass: "middle",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Overall")]), _c('th', {
    attrs: {
      "scope": "col"
    }
  }), _c('th', {
    staticClass: "text-nowrap text-right",
    attrs: {
      "scope": "col"
    }
  }), _c('th', {
    staticClass: "text-center",
    attrs: {
      "scope": "col"
    }
  }), _c('th', {
    staticClass: "text-right middle",
    staticStyle: {
      "max-width": "9rem"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("numFormat")(_vm.overallPointsEarned, "0.00")) + " out of " + _vm._s(_vm.overall.PointsPossible) + " ")]), _c('th', {
    staticClass: "text-right middle",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("asRoundedPercentage")(_vm.overallPointsEarned / _vm.overall.PointsPossible)) + " ")]), _c('th', {
    staticClass: "text-center middle",
    attrs: {
      "scope": "col"
    }
  }, [_c('span', {
    staticClass: "badge p-2 elevate",
    class: `badge-${_vm.overallDesignation.bgColor}`
  }, [_vm._v(_vm._s(_vm.overallDesignation.label))])])])])])])])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row no-gutters align-items-center"
  }, [_c('div', {
    staticClass: "col-4 text-center"
  }), _c('div', {
    staticClass: "col-4 mb-3 text-center font-weight-bold position-relative",
    staticStyle: {
      "z-index": "1"
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "2px solid #000"
    }
  }, [_vm._v("This is the states's data for this measure")]), _c('div', {
    staticClass: "position-absolute",
    staticStyle: {
      "left": "50%",
      "top": "100%",
      "bottom": "-1.3rem",
      "border-left": "2px solid #000"
    }
  })]), _c('div', {
    staticClass: "col-4 text-center"
  })]), _c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-4 text-center"
  }, [_c('div', {
    staticClass: "p-3 bg-dark",
    staticStyle: {
      "opacity": "0.2"
    }
  })]), _c('div', {
    staticClass: "col-4 text-center position-relative",
    staticStyle: {
      "z-index": "0"
    }
  }, [_c('small', {
    staticClass: "position-absolute text-center",
    staticStyle: {
      "top": "20%",
      "left": "0",
      "right": "0",
      "z-index": "1"
    }
  }, [_c('i', {
    staticClass: "fas fa-circle"
  })]), _c('div', {
    staticClass: "p-3 bg-dark",
    staticStyle: {
      "opacity": "0.6",
      "z-index": "0"
    }
  })]), _c('div', {
    staticClass: "col-4 text-center"
  }, [_c('div', {
    staticClass: "p-3 bg-dark",
    staticStyle: {
      "opacity": "0.2"
    }
  })])]), _c('div', {
    staticClass: "row no-gutters align-items-start"
  }, [_c('div', {
    staticClass: "col-4 text-center"
  }, [_c('div', {
    staticClass: "px-2 py-3"
  }, [_vm._v("Data below the "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("minimum standard")]), _vm._v(" receives 0 points.")])]), _c('div', {
    staticClass: "col-4 text-center"
  }, [_c('div', {
    staticClass: "px-2 py-3"
  }, [_vm._v("Data within the gray "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("scoring range")]), _vm._v(" receives points proportionally.")])]), _c('div', {
    staticClass: "col-4 text-center"
  }, [_c('div', {
    staticClass: "px-2 py-3"
  }, [_vm._v("Data at or above the "), _c('strong', {
    staticClass: "text-info"
  }, [_vm._v("target")]), _vm._v(" receives full points.")])])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('thead', {
    staticClass: "table-dark font-weight-bold"
  }, [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }), _c('th', {
    staticClass: "text-center",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Info")]), _c('th', {
    staticClass: "text-nowrap text-right",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("n-size")]), _c('th', {
    staticClass: "text-center",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Performance")]), _c('th', {
    staticClass: "text-right",
    staticStyle: {
      "max-width": "9rem"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("# of points earned out of possible")]), _c('th', {
    staticClass: "text-right",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("% of points earned")]), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10rem"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Designation")])])]);
}];
export { render, staticRenderFns };